import { Link } from "react-router-dom";

export function LargeCard({
  img,
  subtitle,
  title,
  description,
  link,
  comingSoon,
}) {
  return (
    <article className="card-big">
      <Link to={link} style={{ margin: "0" }} className="card-link">
        <div className="image-container">
          <img src={img} alt="project thumbnail" />
        </div>
      </Link>
      <div>
        <h1 className={comingSoon ? "coming-soon-title" : ""}>{title}</h1>
        <p>{description}</p>
      </div>
    </article>
  );
}

export function SmallCard({ img, subtitle, title, link }) {
  return (
    <article className="card-small">
      <Link
        to={link}
        style={{ margin: "0", textDecoration: "none", color: "inherit" }}
      >
        <img src={img} alt="project thumbnail" />
        <h1>{title}</h1>
        <h2>{subtitle}</h2>{" "}
      </Link>
    </article>
  );
}
